import TemplateView from "../TemplateView";

export default class ComponentWithCheckbox extends TemplateView {

    constructor({
            labelComponent = null,
            onChange = () => {},
            containerAdditionalClass = "",
            checkboxAdditionalClass = "",
            checkmarkAdditionalClass = "",
            checkboxTitleAdditionalClass = "",
            tabindex = 0
        }) {
        super();

        this.labelComponent = labelComponent

        this.props = {
            onChange,
            containerAdditionalClass,
            checkboxAdditionalClass,
            checkmarkAdditionalClass,
            checkboxTitleAdditionalClass,
            tabindex
        }

        this.state = {
            checked: false,
            disabled: false,
            indeterminate: false
        }

        this.onStatePropertyChanged("checked", checked => this.checkbox.prop("checked", checked));
        this.onStatePropertyChanged("disabled", disabled => this.checkbox.prop("disabled", disabled));
        this.onStatePropertyChanged("indeterminate", indeterminate => this.$el.toggleClass("indeterminate", indeterminate));
    }

    templateHtml() {
        return "<label class='components_checkboxContainer <%-containerClass%>'>" +
               "  <span class='label <%-titleClass%>'></span>" +
               "  <input type='checkbox' class='checkbox <%-checkboxClass%>' tabindex='<%-tabindex%>'>" +
               "  <span class='checkmark <%-checkmarkClass%>'></span>" +
               "</label>";
    }

    templateModel() {
        return {
            containerClass: this.props.containerAdditionalClass,
            checkboxClass: this.props.checkboxAdditionalClass,
            checkmarkClass: this.props.checkmarkAdditionalClass,
            titleClass: this.props.checkboxTitleAdditionalClass,
            tabindex: this.props.tabindex
        }
    }

    afterRender() {
        this.labelComponent.init(this.find(".label"));
        this.checkbox = this.$el.find(".checkbox");
        this.checkmark = this.$el.find(".checkmark");

        this.$el.on('click', (e) => {
            e.stopPropagation()
        })

        this.checkbox.on("click", (e) => {
            const checked = !this.state.checked
            this.setState({
                checked
            })
            if (this.props.onChange) {
                this.props.onChange({
                    checked: checked,
                    disabled: this.state.disabled
                }, e);
            }
        });
    }

    isChecked() {
        return this.checkbox[0].checked || false;
    }
}


// WEBPACK FOOTER //
// ./web/js/components/ComponentWithCheckbox.js